<template>
  <ppt-modal class="set-hand-weights-modal">
    <header slot="header">
      <h4 class="modal-title">Set hand weights</h4>
      <button class="close" data-dismiss="modal"><span>&times;</span></button>
      <button
        class="btn btn-default clear-selected-hands"
        v-on:click="deselectAllGeneralHands()"
      >
        <span class="full-text">Clear selected hands</span>
        <span class="partial-text">Clear</span>
      </button>
    </header>
    <section slot="body">
      <div v-if="generalHands">
        <grid-selector
          v-if="generalHands"
          v-bind:generalHands="generalHands"
          v-bind:specificHandsNotAllowed="true"
          v-on:selectGeneralHand="selectGeneralHand($event.generalHandString)"
          v-on:deselectGeneralHand="deselectGeneralHand($event)"
          v-on:selectGeneralHands="selectGeneralHands($event)"
          v-on:deselectGeneralHands="deselectGeneralHands($event)"
        />
        <div class="slider-container">
          <span>Weight:</span>
          <vue-slider
            ref="slider"
            v-model="weightToApply"
            v-bind="sliderOptions"
            class="hand-weight-to-apply"
          ></vue-slider>
        </div>
        <button
          class="btn btn-default btn-block"
          v-on:click="applyWeightToSelectedHands()"
        >
          Apply weight to selected hands
        </button>
      </div>
      <div v-else>
        <img src="/static/loading.svg" width="100">
      </div>
    </section>
  </ppt-modal>
</template>

<script>
import GridSelector from '@/components/hand-range/grid-selector/grid-selector';
import PPTModal from '@/components/utilities/modal';
import VueSlider from 'vue-slider-component';
import constants from '@/services/constants';
import GeneralHands from '@/services/hands/GeneralHands';

export default {
  name: 'set-hand-weights-modal',
  components: {
    'grid-selector': GridSelector,
    'ppt-modal': PPTModal,
    'vue-slider': VueSlider,
  },
  props: ['playerStateGeneralHands'],
  data: function () {
    return {
      sliderOptions: {
        min: 5,
        interval: 5,
      },
      weightToApply: 100,
      generalHands: null,
    };
  },
  mounted: function () {
  	let self = this;

  	$(self.$el).on('shown.bs.modal', function () {
      self.initializeGeneralHands();
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.refresh();
        }
      });
    });
  },
  methods: {
    initializeGeneralHands: function () {
      this.generalHands = new GeneralHands();

      this.playerStateGeneralHands.forEach(function (generalHandForPlayer, index) {
        let generalHandForModal = this.generalHands.findByIndex(index);

        if (!generalHandForPlayer.inRange) {
          generalHandForModal.forEachPossibleSpecificHand(function (specificHand) {
            specificHand.maxPossibleWeight = 0;
          });
        }
      }, this);
    },
    selectGeneralHand: function (generalHandString) {
      let generalHand = this.generalHands.find(generalHandString);

      generalHand.forEachPossibleSpecificHand(function (specificHand) {

        if (!specificHand.inRange) {
          specificHand.weight = 100;
        }
      });
    },
    deselectGeneralHand: function (generalHandString) {
      let generalHand = this.generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        specificHand.weight = 0;
      });
    },
    selectGeneralHands: function (generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this.selectGeneralHand(generalHandString);
      }, this);
    },
    deselectGeneralHands: function (generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this.deselectGeneralHand(generalHandString);
      }, this);
    },
    deselectAllGeneralHands: function () {
      let allGeneralHandStrings = constants.handRankings['sklansky-chubukov'];

      this.deselectGeneralHands(allGeneralHandStrings);
    },
    applyWeightToSelectedHands: function () {
      this.$emit('applyExactWeightToGeneralHands', {
        generalHandsFromModal: this.generalHands,
        newWeight: this.weightToApply,
      });
      this.deselectAllGeneralHands();
      $('.set-hand-weights-modal').modal('hide');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "src/assets/arrow-cursors";
  @import "src/assets/grid";

  .modal-header {
    h4 {
      float: left;
      position: relative;
      top: 5px;
    }

    .clear-selected-hands {
      float: right;
    }

    .close {
      margin-left: 15px;
      position: relative;
      top: 5px;
    }
  }

  .partial-text {
    display: none;
  }

  @media (max-width: 352px) {
    .full-text {
      display: none;
    }

    .partial-text {
      display: inline;
    }
  }

  .slider-container {
    display: flex;
    margin-top: 40px;
    margin-bottom: 10px;

    span {
      align-self: flex-end;
    }

    .vue-slider-component {
      flex-grow: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hand-range/hand-weight/set-hand-weights-modal.vue